import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "settings-menu-dropdown bg-white dark:bg-[#0c1427] transition-all shadow-3xl dark:shadow-none p-[20px] absolute mt-[17px] md:mt-[20px] w-[195px] z-[1] top-full ltr:right-0 rtl:left-0 rounded-md"
}
const _hoisted_2 = { class: "inline-block relative rounded-full w-[35px] h-[20px] bg-gray-50 dark:bg-[#0a0e19] ltr:ml-[10px] rtl:mr-[10px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass({
      'leading-none inline-block transition-all relative top-[2px] hover:text-primary-500': true,
      active: _ctx.isActive,
    }),
      id: "settingsMenuDropdown",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("i", { class: "material-symbols-outlined !text-[22px] md:!text-[24px]" }, " settings ", -1)
    ]), 2),
    (_ctx.isActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            type: "button",
            class: "rtl-mode-toggle flex items-center text-black dark:text-white font-medium",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDirection && _ctx.toggleDirection(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.rtlModeText) + ": ", 1),
            _createElementVNode("span", _hoisted_2, [
              _createElementVNode("span", {
                class: "inline-block transition-all absolute h-[12px] w-[12px] bg-black dark:bg-white rounded-full top-1/2 -translate-y-1/2",
                style: _normalizeStyle({
            left: _ctx.direction === 'ltr' ? '4px' : 'calc(100% - 16px)',
          })
              }, null, 4)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}